import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const EmptyStateContainer = styled.div`
  margin: ${props =>
    props.marginTop !== undefined
      ? `${props.marginTop}px auto 0 auto`
      : "85px auto 0 auto"};
  height: 281px;
  width: 320px;
  display: flex;
  justify-content: center;
  align-items: center;
  .empty-state-main-container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;

    .empty-state-tab-icon {
      width: 72px;
      height: 72px;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-bottom: 12px;
      &:before {
        margin: 0;
        font-size: 53px;
        color: ${Variables.colors.complementary_500};
      }
    }

    .svg-icon-wrapper {
      margin-bottom: 12px;
      display: flex;
      path {
        fill: ${Variables.colors.complementary_500};
        stroke: ${Variables.colors.complementary_500};
      }
    }

    .empty-state-message-container {
      font-size: ${Variables.font_sizes.x_medium};
      color: ${Variables.colors.complementary_600};
      line-height: 1.57;
      letter-spacing: -0.35px;
      text-align: center;
      margin-bottom: 8px;
    }

    .empty-state-link {
      cursor: pointer;
      text-decoration: none;
      font-size: ${Variables.font_sizes.x_medium};
      font-weight: ${Variables.font_weight.medium};
      color: ${Variables.colors.primary_vivid};
      text-align: center;
      margin-bottom: 15px;
      &:visited,
      &:hover,
      &:focus {
        color: ${Variables.colors.primary_vivid};
      }
    }

    .empty-state-info-icon {
      width: 40px;
      height: 40px;
      display: flex;
      justify-content: center;
      align-items: center;
      &:before {
        margin: 0;
        font-size: 20px;
        color: ${Variables.colors.complementary_600};
      }
    }
  }
`;
